module.exports = __webpack_public_path__ + "img/securetrading.4e35aa60.svg";